# How to use this file:
# - Please name the project files as organization_project or person_project or team_project
# - Keep the same name for import variables
# - Add a comment behind the project containing the project id in Weaver
# - Sort the imports and specialConfig based on the name (so inject new ones instead of end of list)
# - Check if the defaultConfig isnt already sufficient (in that case no edit is needed here)
# - The project names in Weaver are base64 encoded. We do that so they dont literally be found in the source code. The comments get filtered out during build.

# Special config
import degroeneboog_pms from './degroeneboog_pms'
import gelregroen_pms from './gelregroen_pms'
import pallas_2019 from './pallas_2019'
import pallas_iim from './pallas_iim'
import pallas_rdl from './pallas_rdl'
import pallas_data from './pallas_data'
import testServer from './test-server'

specialConfig =  {

  # De Groeneboog
  'cG1zLWRnYi1kYXRh': degroeneboog_pms # pms-dgb-data

  # GelreGroen
  'cG1zLWdnLXhsLXRlc3Q=': gelregroen_pms # pms-gg-xl-test
  'cG1zLWdnLWRldg==': gelregroen_pms     # pms-gg-dev

  'Y2s5c3I0dnl2MDAwMWdveGttMWtjbTN1bw==': gelregroen_pms # ck9sr4vyv0001goxkm1kcm3uo
  'Z2ctdGVzdC0y': gelregroen_pms # gg-test-2
  'Y2tjazN6Y3VvMDAwMzEyNWNveTN6dmZ0Zw==': gelregroen_pms # ckck3zcuo0003125coy3zvftg
  'Y2tjbjJiNW8yMDAwMnhveGt0MmNwZDhhcg==': gelregroen_pms # ckcn2b5o20002xoxkt2cpd8ar (Ontwikkeling)

  # Pallas
  'MjAxOTEyMDItcGFsbGFz': pallas_2019 # 20191202-pallas
  'cGFsbGFzLXNxdWFzaC1paW0=': pallas_iim # pallas-squash-iim
  'cGFsbGFzLXJkbC0y': pallas_rdl # pallas-rdl-2
  'Y2s5ZDRnbXhqMDAwNDNseGtuMXRqN3Rscg==': pallas_data # ck9d4gmxj00043lxkn1tj7tlr
  'cGFsbGFzLWRhdGEtdGVzdC01': pallas_data # pallas-data-test-5

  # TEST SERVER
  'dGVzdC1zZXJ2ZXI=': testServer
}

# Default config applies to all projects automatically which have no specialConfig defined
import defaultConfig from './default'

export default (id) ->
  if specialConfig[id]? then specialConfig[id] else defaultConfig
